/* eslint-disable camelcase */
import { UtmCampaign, UtmAcquisitionProduct } from 'Models/Utm';

export const utmCampaignToAcquisitionProduct = (campaign: string) => {
  switch (campaign) {
    case UtmCampaign.CASH_INSTALLMENTS_LANDING:
      return UtmAcquisitionProduct.PERSONAL_LOANS;
    default:
      return null;
  }
};
